
import React, { Component } from 'react';
import './App.css';
import dotenv from 'dotenv';                        //Import variables with private information from .env file
import Nav from './components/Nav.js';              //Import Navigation Bar
import Header from './components/Header';           //Import Website Banner
import About from './components/About';             //Import the introductory section
import Services from './components/Services';       //Import Services offered 
import Clients from './components/Clients';         //Import Clients served
import ContactForm from './components/ContactForm'; //Import Contact Form
import Footer from './components/Footer';           //Import the footer that contains company information and contact information

// This is the main component of the app. It links to all the components that the website is divided into
// The component files can be found in src/components/

class App extends Component {
  render() {
    dotenv.config();
    return (
      <div className="App">        
        <Nav/>       
        <Header/>
        <About/>
        <Services/>
        <Clients/>
        <ContactForm/>
        <Footer/>
      </div>
    );
  }
}

export default App;
